import React from 'react';
import { useSelector } from 'react-redux';

import { Checkbox, Input, Select, Typography, Flex, InputNumber, Space } from 'antd';
import FileUpload from '../../../../../../../components/FileUpload';

import { conditionalFields } from './const';
import AttachmentImageViewModal from '../../../../../../../components/Modal/AttachmentImageViewModal';

const { Text } = Typography;
const conditionalOutcome = conditionalFields['CITATIONS'];

export const TableCol = (action, status) => {
  const _static = useSelector((state) => state.static);
  const { staticData } = _static;
  const { research_point_data: researchPointData, outcome_type: outComeType } =
    staticData;

  return [
    {
      key: 'outcome',
      dataIndex: 'outcome',
      title: 'Outcome',
      render: (value, row) => {
        const _researchPointData = researchPointData.filter(
          (item) => item.id === value
        );
        const _researchPoint = _researchPointData[0];

        return (
          <Select
            style={{ width: '300px', minHeight: '88px' }}
            disabled={status === 1 || status === 2 || status === 3}
            options={[
              ...researchPointData.map((item) => ({
                value: item.id,
                outcomeId: item.outcome_type,
                label: (
                  <Flex vertical>
                    <Text>
                      {
                        outComeType.find(
                          (outcome) => outcome.value === item.outcome_type
                        ).label
                      }
                    </Text>
                    <Text>{item.publishing_venue}</Text>
                    <Text type="secondary">({item.point} APA Points)</Text>
                  </Flex>
                )
              }))
            ]}
            defaultValue={_researchPoint.id}
            placeholder="Select a Event"
            onChange={(e) => {
              const updatedRow =
                e === conditionalOutcome
                  ? {
                    ...row,
                    is_lead_author: false,
                    title_or_description: '',
                    point_split_percentage: 0,
                    has_multiple_iub_authors: false,
                    citation: 0,
                    outcome: e
                  }
                  : { ...row, outcome: e };
              action(updatedRow);
            }}
          />
        );
      }
    },
    {
      key: 'is_lead_author',
      dataIndex: 'is_lead_author',
      title: 'Single Author',
      render: (value, row) =>
        row.outcome === conditionalOutcome ? (
          ''
        ) : (
          <Checkbox
            placeholder="Enter"
            defaultChecked={value}
            disabled={status === 1 || status === 2 || status === 3}
            onChange={(e) =>
              action({ ...row, is_lead_author: e.target.checked })
            }
          />
        )
    },
    {
      key: 'title_or_description',
      dataIndex: 'title_or_description',
      title: 'Working Title / Brief Description',
      render: (value, row) =>
        row.outcome === conditionalOutcome ? (
          ''
        ) : (
          <Input
            placeholder="Enter"
            value={value}
            disabled={status === 1 || status === 2 || status === 3}
            onChange={(e) =>
              action({ ...row, title_or_description: e.target.value })
            }
          />
        )
    },
    {
      key: 'has_external_authors',
      dataIndex: 'has_external_authors',
      title: 'External Authors',
      render: (value, row) => (
        <Checkbox
          placeholder="Enter"
          defaultChecked={value}
          disabled={status === 1 || status === 2 || status === 3}
          checked={value}
          onChange={(e) => {
            action({
              ...row,
              has_external_authors: e.target.checked,
            });
          }}
        />
      )
    },
    {
      key: 'has_multiple_iub_authors',
      dataIndex: 'has_multiple_iub_authors',
      title: 'Multiple IUB Authors',
      render: (value, row) =>
        row.outcome === conditionalOutcome ? (
          ''
        ) : (
          <Checkbox
            placeholder="Enter"
            defaultChecked={value}
            disabled={status === 1 || status === 2 || status === 3}
            onChange={(e) =>
              action({ ...row, has_multiple_iub_authors: e.target.checked })
            }
          />
        )
    },
    {
      key: 'point_split_percentage',
      dataIndex: 'point_split_percentage',
      title: 'Point Percentage',
      render: (value, row) =>
        row.outcome === conditionalOutcome ? (
          ''
        ) : (
          <InputNumber
            placeholder="Enter"
            value={value}
            disabled={status === 1 || status === 2 || status === 3}
            onChange={(e) => action({ ...row, point_split_percentage: e })}
          />
        )
    },
    {
      key: 'citation',
      dataIndex: 'citation',
      title: 'No of Citation',
      render: (value, row) =>
        row.outcome !== conditionalOutcome ? (
          ''
        ) : (
          <Input
            placeholder="Enter"
            value={value}
            disabled={status === 1 || status === 2 || status === 3}
            onChange={(e) => action({ ...row, citation: e.target.value })}
          />
        )
    },
    {
      key: 'upload',
      dataIndex: 'attachment',
      title: 'Attachments(Doc of Agreement)',
      render: (fileList, row) => (
        <Space>
          <FileUpload fileList={fileList} row={row} action={action} disabled={status === 1 || status === 2 || status === 3} status={status} />

          <AttachmentImageViewModal
            row={row}
            parentKey="attachment"
            title="Course Attachments"
          // status={status}
          />
        </Space>
      )
    },
    {
      key: 'apa_point',
      dataIndex: 'apa_point',
      title: 'APA Point'
    }
  ];
};
